export class AgentSessionEndEvent {
  constructor(json) {
    this.type = json.Type;
  }
}
